import type { ComponentPropsWithRef, ReactNode } from "react";
import { clsx } from "clsx";

export const TAG_VARIANTS = ["primary", "secondary", "error", "success", "warning", "info", "offwhite"] as const;

type Variant = (typeof TAG_VARIANTS)[number];

// Extends span props so asChild consumers (e.g. Radix Tooltip.Trigger) can inject
// their ref and event handlers.
type TagProps = ComponentPropsWithRef<"span"> & {
  children: ReactNode;
  variant?: Variant;
  className?: string;
}

const classNames: Record<Variant, string> = {
  primary: "bg-primary-100 text-white",
  secondary: "bg-gray-800/10 text-gray-800",
  error: "bg-error-50 text-error-800",
  success: "bg-success-50 text-success-900",
  warning: "bg-warning-50 text-warning-800",
  info: "bg-info-50 text-info-900",
  offwhite: "bg-offwhite-300 text-offwhite-700",
};

export const Tag = ({ children, variant = "secondary", className, ...rest }: TagProps) => (
  <span
    {...rest}
    className={clsx(
      "inline! flex w-fit items-center gap-1 rounded px-2 py-1 font-area text-xs",
      classNames[variant],
      className,
    )}>
    {children}
  </span>
);
